export default __webpack_public_path__ + "static/media/chvideo.5e3a0e09.png";